export default "__VITE_ASSET__CkEdBdmk__"